import { render, staticRenderFns } from "./Filebrowser.vue?vue&type=template&id=38d0b8ca&scoped=true"
import script from "./Filebrowser.vue?vue&type=script&lang=js"
export * from "./Filebrowser.vue?vue&type=script&lang=js"
import style0 from "./Filebrowser.vue?vue&type=style&index=0&id=38d0b8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0b8ca",
  null
  
)

export default component.exports